export enum HoverCardPlacements {
  Top = 'top',
  Bottom = 'bottom',
  Right = 'right',
  Left = 'left',
}

export enum HoverCardAlignment {
  Start = 'start',
  Center = 'center',
  End = 'end',
}
